<template>
  <div>
    <nav class="pagination" role="navigation" aria-label="pagination">
      <a
        class="pagination-previous"
        :disabled="currentPage == 1"
        @click="previousPage"
        v-t="'Admin.pagination_previous'"
      ></a>
      <a
        class="pagination-next"
        :disabled="currentPage == pageCount"
        @click="nextPage"
        v-t="'Admin.pagination_next'"
      ></a>
      <ul class="pagination-list">
        <li v-for="page in paginationTriggers" :key="page">
          <a
            class="pagination-link"
            :class="{ 'is-current': currentPage == page }"
            :aria-label="
              `Goto
            page
            ${page}`
            "
            >{{ page }}</a
          >
        </li>
        <!--li v-if="totalPages > 5">
                <span class="pagination-ellipsis">&hellip;</span>
              </li-->
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    },
    visiblePagesCount: {
      type: Number,
      default: 5
    }
  },
  computed: {
    paginationTriggers () {
      const currentPage = this.currentPage
      const pageCount = this.pageCount
      const visiblePagesCount = Math.min(
        this.visiblePagesCount,
        this.pageCount
      )
      const visiblePagesThreshold = (visiblePagesCount - 1) / 2

      if (visiblePagesThreshold === 0) {
        return [1]
      }
      const paginationTriggersArray = Array(visiblePagesCount - 1).fill(0)

      if (currentPage <= visiblePagesThreshold + 1) {
        paginationTriggersArray[0] = 1
        const paginationTriggers = paginationTriggersArray.map(
          (paginationTrigger, index) => {
            return paginationTriggersArray[0] + index
          }
        )
        paginationTriggers.push(pageCount)
        return paginationTriggers
      }

      if (currentPage >= pageCount - visiblePagesThreshold + 1) {
        const paginationTriggers = paginationTriggersArray.map(
          (paginationTrigger, index) => {
            return pageCount - index
          }
        )
        paginationTriggers.reverse().unshift(1)
        return paginationTriggers
      }

      paginationTriggersArray[0] = currentPage - visiblePagesThreshold + 1
      const paginationTriggers = paginationTriggersArray.map(
        (paginationTrigger, index) => {
          return paginationTriggersArray[0] + index
        }
      )
      paginationTriggers.unshift(1)
      paginationTriggers[paginationTriggers.length - 1] = pageCount
      return paginationTriggers
    }
  },
  methods: {
    nextPage () {
      if (this.currentPage !== this.pageCount) {
        this.$emit('nextPage')
      }
    },
    previousPage () {
      if (this.currentPage > 1) {
        this.$emit('previousPage')
      }
    }
  }
}
</script>

<style>
</style>
